import { Modal, ModalTabs, PDFRenderer, Show } from "components";
import { useMatch, useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import config from "config";
import _ from "lodash";
import { useTreaty } from "hooks/data/use-treaties";
import { AccountPeriodsNames, classNames, useUrlState, wrapClick } from "utils";
import { useEffect, useState } from "react";
import { useSetState } from "react-use";

const modalTabs = [
    { name: "Treaty Closings", href: "TREATY_CLOSINGS" },
    { name: "NIC Schedule", href: "NIC_SCHEDULE" },

]


export default function ViewTreatyClosingContainer({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const [orderTab, setOrderTab] = useState("");
    const [modalTab, setModalTab] = useState("TREATY_CLOSINGS");

    const { params } = useMatch<LocationGenerics>();
    useMatch<LocationGenerics>();

    const { treaty, loading } = useTreaty({
        treatyId: params?.treaty
    });

    const __setOrderTab = (tab: string) => () => {
        setOrderTab(tab);
    };

    useEffect(() => {
        if (treaty) {
            setOrderTab(_.first(treaty?.treaty_accounts)?.treaty_account_id || "")
        }
    }, [treaty])
    const isSpecialProgram = /fire|general accident/g.test(
        treaty?.treaty_program?.treaty_name?.toLowerCase() || ""
    );
    const portfolioUrl = isSpecialProgram ? "treaty_portfolio_statement" : "treaty_profit_commission";

    const urls = {
        TREATY_CLOSINGS: `${config.asset.uri}generate_treaty_credit_note/${btoa(
            JSON.stringify({ "participant_id": searchParams?.id, "treaty_account_id": orderTab, "type": 0 })
        )}`,

        NIC_SCHEDULE: `${config.asset.uri}treaty_nic_schedule/${btoa(
            JSON.stringify({
                treaty_id: treaty?.treaty_id,
                insurer_id: treaty?.insurer?.insurer_id,
                from: treaty?.treaty_deduction?.treaty_period_from,
                to: treaty?.treaty_deduction?.treaty_period_to,
                period: treaty?.treaty_accounts?.find(
                    (el) => el?.treaty_account_id === orderTab
                )?.account_periods,
                currency: treaty?.currency,
                type: treaty?.treaty_program?.treaty_type,
            })
        )}`,
        PROFIT_COMMISSION: `${config.asset.uri}${portfolioUrl}/${btoa(
            JSON.stringify({
                treaty_participation_id: searchParams?.id,
                treaty_id: treaty?.treaty_id,
            })
        )}`,
    }


    return (
        <Modal
            open={open}
            setOpen={setOpen}
            size="6xl"
            hidePadding
            loading={loading}
            title={"Preview Treaty Documents"}
            description={"Preview and download treaty documents such as closing notes, NIC schedules, and profit commission reports."}
        >
            {/* {orderTab} */}
            <ModalTabs
                tabs={[...modalTabs, ...(!isSpecialProgram ? [{ name: "Profit Commision", href: "PROFIT_COMMISSION" }] : [{ name: "Portfolio Statement", href: "PROFIT_COMMISSION" }])]}
                setOrderStatus={setModalTab}
                orderStatus={modalTab}
            />

            <Show if={modalTab !== "PROFIT_COMMISSION"}>
                <ModalTabs
                    tabs={treaty?.treaty_accounts?.map(el => ({
                        name: _.get(AccountPeriodsNames, el?.account_periods || "") || "",
                        href: el?.treaty_account_id || ""
                    })) || []}
                    setOrderStatus={setOrderTab}
                    orderStatus={orderTab}
                />
            </Show>
            <Show if={!_.isEmpty(orderTab)}>
                <div className="p-3">
                    <PDFRenderer
                        url={_.get(urls, modalTab, "")}
                    />
                </div>
            </Show>
        </Modal>
    );
}
